import React from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";
export const Dblogs = ({mypost})=>{
    const deletePost = (password, id)=>{
      alert(password)
      if (password=="Smally@281001"){
      var option = {
      method: 'DELETE',
      url: `https://karlson.herokuapp.com/api/post/${id}`,
      headers: {
        "Content-type": "application/json; charset=UTF-8"
      },
      data: JSON.stringify({
        "password": password
      })
      };

      axios
      .request(option)
      .then(function(response) {
        alert(response.data.message)
      })
      .catch(function(err) {
        alert(err)
      });  
    }
      else{
        alert("STFU!")
      }
  }
    return (
    <>
    <br/>
    <div className="card my-0">  
    <div className="card-body">
    <h5 className="card-title">{mypost.title}</h5>
    <p className="card-text">
    {mypost.content.split(' ').slice(0,52).join(' ') + '...read more'}
    </p>
    <Link to={"/dashboard/edit/"+mypost.slug} className="float-left sbtn next-arrow-btn green-btn mx-2">
    Edit Blog
    </Link>
    <a onClick={()=>{
      var pass = prompt("Enter Security Key","")
      deletePost(pass, mypost.sno)
    }} className="float-left sbtn next-arrow-btn red-btn mx-2">
    Delete Blog
    </a>
    </div>
    </div>
    </>
       
)}